/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Pressure } from './Pressure';
import {
    instanceOfPressure,
    PressureFromJSON,
    PressureFromJSONTyped,
    PressureToJSON,
} from './Pressure';

/**
 * @type AnalysisResultDtoAirPressure
 * 
 * @export
 */
export type AnalysisResultDtoAirPressure = Pressure;


export function AnalysisResultDtoAirPressureFromJSON(json: any): AnalysisResultDtoAirPressure {
    return AnalysisResultDtoAirPressureFromJSONTyped(json, false);
}

export function AnalysisResultDtoAirPressureFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnalysisResultDtoAirPressure {
    if (json == null) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...PressureFromJSONTyped(json, true) };
    return  PressureFromJSONTyped(json, true);
}

export function AnalysisResultDtoAirPressureToJSON(value?: AnalysisResultDtoAirPressure | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfPressure(value)) {
        return PressureToJSON(value as Pressure);
    }

    return {};
}

/**
 * Check if a given object implements the AnalysisResultDtoAirPressure interface.
 */
export function instanceOfAnalysisResultDtoAirPressure(value: any): value is AnalysisResultDtoAirPressure {
    if (instanceOfPressure(value)) return true;
    return false;
}

